import { createSelector } from 'reselect'

const getListData = createSelector(
	[state => state.themes],
	themes => ({
		themes,
	})
)

export default {
	getListData,
}
